import {
  ListTileType,
  Query,
  SdActionType,
  TileType,
} from '@varo/graphql-schema-types';
import { BorrowingPowerScreenCallbacks } from 'features/borrowingPower/BorrowingPowerScreen/adapters/types';
import useFormatBorrowingPowerData, {
  BorrowingPowerScreenContent,
} from 'features/borrowingPower/BorrowingPowerScreen/useFormatBorrowingPowerData/useFormatBorrowingPowerData';
import FetchDMGMScreenTiles from 'services/graphql/queries/FetchDMGMScreenTiles';
import { CoreError } from 'shared/utils/errors/CoreError';
import { Maybe } from 'shared/utils/types';
import { CombinedError, useQuery, UseQueryExecute } from 'urql';

const dmgmInput = {
  tileType: [
    TileType.TileServiceTile,
    TileType.GroupedContentSectionScreenTile,
    TileType.List,
    TileType.FullWidthTextComponentTile,
    TileType.HtmlComponentTile,
    TileType.SdInlineAlertTile,
  ],
  listTileType: [ListTileType.AdvanceTitledListTile, ListTileType.InfoListTile],
  supportedActionTypes: [
    SdActionType.SdDeepLinkAction,
    SdActionType.SdOpenWebUrl,
    SdActionType.SdOpenPdfUrl,
  ],
};

type BorrowingPowerScreenData = {
  content?: Maybe<BorrowingPowerScreenContent>;
  error?: Maybe<CoreError | CombinedError>;
  fetching: boolean;
  refetch: UseQueryExecute;
};

const useBorrowingPowerScreenData = (
  screenCallbacks: BorrowingPowerScreenCallbacks,
): BorrowingPowerScreenData => {
  // NOTE: this screen is using a query that pre-dates cruise and is not aligned
  // with our new component system. for this reason the response is heavily
  // adapted on the client side to fit our requirements. new features to this
  // screen should be implemented using a new query that matches the new components.
  const [response, refetch] = useQuery<Query>({
    query: FetchDMGMScreenTiles,
    variables: { input: dmgmInput },
    requestPolicy: 'network-only',
  });

  const { data } = response;
  const formattedResponse = useFormatBorrowingPowerData(
    data?.dMGMScreenTiles,
    screenCallbacks,
  );

  return {
    ...response,
    ...formattedResponse,
    refetch,
  };
};

export default useBorrowingPowerScreenData;
